/**
 * The studio dashboard — a facilitator's home. Spec 11.3: credit balance, upcoming and recent
 * sessions, quick "New session". The screen is `features/facilitator/FacilitatorDashboard`.
 */
import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { FacilitatorDashboard } from '../../../features/facilitator/FacilitatorDashboard';

export const Route = createFileRoute('/$lang/studio/')({ component: Page });

function Page(): ReactNode {
  const { lang } = Route.useParams();
  return <FacilitatorDashboard lang={lang} />;
}
